/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DeviceNmsResponse } from '../models/device-nms-response';
import { DeviceSupplierDto } from '../models/device-supplier-dto';
import { DeviceTypeDto } from '../models/device-type-dto';
import { FarmDto } from '../models/farm-dto';
import { getDevices } from '../fn/nms/get-devices';
import { GetDevices$Params } from '../fn/nms/get-devices';
import { getDeviceSuppliers } from '../fn/nms/get-device-suppliers';
import { GetDeviceSuppliers$Params } from '../fn/nms/get-device-suppliers';
import { getDeviceTypes } from '../fn/nms/get-device-types';
import { GetDeviceTypes$Params } from '../fn/nms/get-device-types';
import { getFarms } from '../fn/nms/get-farms';
import { GetFarms$Params } from '../fn/nms/get-farms';
import { getHouses } from '../fn/nms/get-houses';
import { GetHouses$Params } from '../fn/nms/get-houses';
import { getHouseWithCrops } from '../fn/nms/get-house-with-crops';
import { GetHouseWithCrops$Params } from '../fn/nms/get-house-with-crops';
import { HouseDto } from '../models/house-dto';

@Injectable({ providedIn: 'root' })
export class NmsService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDeviceTypes()` */
  static readonly GetDeviceTypesPath = '/api/nms/device-type';

  /**
   * Get Device Types.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceTypes$Response(params?: GetDeviceTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceTypeDto>> {
    return getDeviceTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Device Types.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeviceTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceTypes(params?: GetDeviceTypes$Params, context?: HttpContext): Observable<DeviceTypeDto> {
    return this.getDeviceTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceTypeDto>): DeviceTypeDto => r.body)
    );
  }

  /** Path part for operation `getDevices()` */
  static readonly GetDevicesPath = '/api/nms/devices';

  /**
   * Get Devices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDevices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevices$Response(params: GetDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceNmsResponse>> {
    return getDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Devices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDevices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDevices(params: GetDevices$Params, context?: HttpContext): Observable<DeviceNmsResponse> {
    return this.getDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceNmsResponse>): DeviceNmsResponse => r.body)
    );
  }

  /** Path part for operation `getFarms()` */
  static readonly GetFarmsPath = '/api/nms/farms';

  /**
   * Get Farms.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFarms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFarms$Response(params: GetFarms$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
    return getFarms(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Farms.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFarms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFarms(params: GetFarms$Params, context?: HttpContext): Observable<FarmDto> {
    return this.getFarms$Response(params, context).pipe(
      map((r: StrictHttpResponse<FarmDto>): FarmDto => r.body)
    );
  }

  /** Path part for operation `getHouses()` */
  static readonly GetHousesPath = '/api/nms/houses';

  /**
   * Get Houses.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHouses()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHouses$Response(params: GetHouses$Params, context?: HttpContext): Observable<StrictHttpResponse<HouseDto>> {
    return getHouses(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Houses.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHouses$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHouses(params: GetHouses$Params, context?: HttpContext): Observable<HouseDto> {
    return this.getHouses$Response(params, context).pipe(
      map((r: StrictHttpResponse<HouseDto>): HouseDto => r.body)
    );
  }

  /** Path part for operation `getHouseWithCrops()` */
  static readonly GetHouseWithCropsPath = '/api/nms/housesWithCrops';

  /**
   * Get House With Crops.
   *
   * Returns list of house IDs with open flock
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHouseWithCrops()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHouseWithCrops$Response(params: GetHouseWithCrops$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<number>>> {
    return getHouseWithCrops(this.http, this.rootUrl, params, context);
  }

  /**
   * Get House With Crops.
   *
   * Returns list of house IDs with open flock
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHouseWithCrops$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHouseWithCrops(params: GetHouseWithCrops$Params, context?: HttpContext): Observable<Array<number>> {
    return this.getHouseWithCrops$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<number>>): Array<number> => r.body)
    );
  }

  /** Path part for operation `getDeviceSuppliers()` */
  static readonly GetDeviceSuppliersPath = '/api/nms/suppliers';

  /**
   * Get Device Suppliers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDeviceSuppliers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceSuppliers$Response(params?: GetDeviceSuppliers$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceSupplierDto>> {
    return getDeviceSuppliers(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Device Suppliers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDeviceSuppliers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDeviceSuppliers(params?: GetDeviceSuppliers$Params, context?: HttpContext): Observable<DeviceSupplierDto> {
    return this.getDeviceSuppliers$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceSupplierDto>): DeviceSupplierDto => r.body)
    );
  }

}
